import styled from 'styled-components'
import CloudinaryImage from 'react-cloudinary-lazy-image'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'

import Button from 'src/components/Button'
import { applyPromo, promos } from 'src/lib/controller'
import {
	promoLoadingCustomToast,
	getErrorCustomToast,
	TOAST_DURATION,
	Backdrop,
} from 'src/components/Toaster'
import config from 'src/lib/config'
import { Container, Title, Description, Highlight } from './index'

const Prices = ({ setShowToastBackdrop }) => {
	// const navigate = useNavigate()

	return (
		<>
			<Container>
				<Title>Push promos & new prices, <Highlight>instantly</Highlight></Title>
				<Description>
					See prices and promotions update instantly across your Micromart™ Smart Stores.
				</Description>
				<Content>
					<Selection setShowToastBackdrop={setShowToastBackdrop} />
					<Display />
				</Content>
			</Container>
		</>
	)
}

const Display = () => {
	return (
		<DisplayContainer>
			<DisplayContent>
				<CloudinaryImage
					cloudName='kitchenmate'
					imageName='Gen4/Portal/e-tag'
					fixed={{
						width: Math.round(1394 * config.resize) / 2,
						height: Math.round(762 * config.resize) / 2,
					}}
				/>
				<PriceContainer>
					<DiscountedPrice>
						$3.38
						<OriginalPrice>$4.50</OriginalPrice>
					</DiscountedPrice>
				</PriceContainer>
			</DisplayContent>
		</DisplayContainer>
	)
}

const Selection = ({ setShowToastBackdrop }) => {
	const apply = (promo) => {
		setShowToastBackdrop(true)
		const update = applyPromo(promo)
		toast.promise(update, {
			loading: promoLoadingCustomToast,
			success: () => {
				setTimeout(() => setShowToastBackdrop(false), TOAST_DURATION)
				return 'Applied promo!'
			},
			error: (error) => {
				setTimeout(() => setShowToastBackdrop(false), TOAST_DURATION)
				return getErrorCustomToast(error)
			},
		})
	}

	return (
		<SelectionContainer>
			<SelectionTitle>Select promo</SelectionTitle>
			<List>
				<ListItem>
					<Option onClick={() => apply(promos.frozen)}>
						<PromoGraphic>
							<PromoImage
								src={`${process.env.PUBLIC_URL}/promos/bogo-ice-cream.png`}
								alt=""
							/>
						</PromoGraphic>
						<PromoText>Buy 1 Get 1 Ice Cream</PromoText>
					</Option>
				</ListItem>
				<ListItem>
					<Option onClick={() => apply(promos.drink)}>
						<PromoGraphic>
							<CloudinaryImage
								cloudName='kitchenmate'
								imageName='Gen4/Portal/NRF_Coca_Cola_Classic'
								fixed={{
									width: Math.round(171 * config.resize),
									height: Math.round(173 * config.resize),
								}}
							/>
						</PromoGraphic>
						<PromoText>Free drink with a meal</PromoText>
					</Option>
				</ListItem>
			</List>
		</SelectionContainer>
	)
}

const Content = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
	padding-left: ${Math.round(100 * config.resize)}px;
`

const DisplayContainer = styled.div`
	flex: 1;
	margin-left: -${Math.round(100 * config.resize)}px;
`

const DisplayContent = styled.div`
	position: relative;
	padding-top: ${Math.round(40 * config.resize)}px;
`

const SelectionContainer = styled.div`
	flex: 1;
	padding-top: 10px;
`

const List = styled.ul`
	list-style-type: none;
	display: flex;
	flex-direction: column;
	padding: 0;
	margin-top: ${Math.round(20 * config.resize)}px;
	gap: ${Math.round(30 * config.resize)}px;
`

const ListItem = styled.li`
	height: ${Math.round(217 * config.resize)}px;
`

const Option = styled.button`
	background: #F6F6F6;
	border: 1px solid #DCD7D7;
	height: ${Math.round(217 * config.resize)}px;
	width: ${Math.round(564 * config.resize)}px;
	border-radius: ${Math.round(20 * config.resize)}px;
	box-shadow: 0px 16px 48px 0px rgba(0, 0, 0, 0.05);
	display: flex;
	align-items: center;
	gap: ${Math.round(40 * config.resize)}px;
	justify-content: flex-start;
	padding-left: ${Math.round(40 * config.resize)}px;
`

const Price = styled.p`
	color: #139051;
	font-size: ${Math.round(30 * config.resize)}px;
	font-family: "GothamMedium";
	bottom: ${Math.round(140 * config.resize)}px;
	left: ${Math.round(180 * config.resize)}px;
	position: absolute;
	margin: 0;
`

const PriceContainer = styled(Price)``
const DiscountedPrice = styled.span`
	display: inline-flex;
	align-items: center;
	gap: ${Math.round(14 * config.resize)}px;
`
const OriginalPrice = styled.span`
	font-size: ${Math.round(24 * config.resize)}px;
	text-decoration: line-through;
	color: gray;
`

const PromoGraphic = styled.div`
	width: ${Math.round(171 * config.resize)}px;
	height: ${Math.round(173 * config.resize)}px;
	display: flex;
	align-items: center;
	justify-content: center;
`

const PromoImage = styled.img`
	width: 100%;
	height: 100%;
	object-fit: contain;
	display: block;
`

const PromoText = styled.p`
	font-family: "GothamMedium";
	font-size: ${Math.round(40 * config.resize)}px;
	line-height: 125%;
	margin: 0;
	text-align: left;
`

const SelectionTitle = styled.h4`
	font-size: ${Math.round(40 * config.resize)}px;
	line-height: ${Math.round(50 * config.resize)}px;
	font-weight: bold;
	margin: 0;
`

const NextButton = styled(Button)`
	position: absolute;
	bottom: ${Math.round(100 * config.resize)}px;
	right: ${Math.round(110 * config.resize)}px;
`

export default Prices
